import { Routing } from "@common/_constants";
import { ErrorService, format } from "@common/_services";
import { refetch } from "@common/_services/refetch";
import { CreateLogger } from "@common/utils/logger";

export const JobService = {
    search,
    getMyJobs,
    getRecommendedJobs,
    suggest,
    signAgreement,
    leave,
    canLeave,
    get,
    declineReasons,
};
const logger = CreateLogger("job.service");

function declineReasons(abortSignal: AbortSignal) {
    const url = Routing.Api.Pro.Referrals.DECLINE_REASONS;
    const settings = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        signal: abortSignal,
    };
    return refetch(url, settings).then(unwrapResult);
}

function search(options, abortSignal: AbortSignal) {
    const url = Routing.Api.Pro.Jobs.SEARCH;
    const settings: RequestInit = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(options),
        signal: abortSignal,
    };
    return refetch(url, settings).then(unwrapResult);
}

function getMyJobs(abortSignal: AbortSignal) {
    const options = {
        scope: 2, // my
        page_size: 10,
    };
    return search(options, abortSignal);
}

function getRecommendedJobs(abortSignal: AbortSignal) {
    const url = Routing.Api.Pro.Jobs.RECOMMENDED_JOBS;

    const settings = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        signal: abortSignal,
    };
    return refetch(url, settings).then(unwrapResult);
}

function suggest(term, abortSignal: AbortSignal) {
    const url = `${Routing.Api.Pro.Jobs.SUGGEST}?query=${term}`;
    const settings: RequestInit = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        signal: abortSignal,
    };
    return refetch(url, settings).then(unwrapResult);
}

function signAgreement(jobId) {
    const url = format(Routing.Api.Pro.Jobs.LEAVE, { id: jobId });
    const settings: RequestInit = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
    };
    return refetch(url, settings).then(unwrapResult);
}

function leave(jobId) {
    const url = format(Routing.Api.Pro.Jobs.LEAVE, { id: jobId });
    const settings: RequestInit = {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
    };
    return refetch(url, settings).then(unwrapResult);
}

function canLeave(jobId, abortSignal: AbortSignal) {
    const url = format(Routing.Api.Pro.Jobs.LEAVE, { id: jobId });
    const settings: RequestInit = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        signal: abortSignal,
    };
    return refetch(url, settings).then(unwrapResult);
}

function get(jobId, abortSignal: AbortSignal) {
    const url = format(Routing.Api.Pro.Jobs.DETAILS, { id: jobId });
    const settings: RequestInit = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        signal: abortSignal,
    };
    return refetch(url, settings).then(unwrapResult);
}

// helpers...
// TODO: This may be useful for all services.
function unwrapResult(response) {
    return ErrorService.handleErrors(response)
        .then(resp => resp.json())
        .then(json => json.result);
}
